import axios from 'axios'
import { GRAPHQL_API_URL } from '../../Constants'

export const gqlSend = async ({ query, req, headers }) => {
  try {
    const response = await axios.post(
      GRAPHQL_API_URL,
      {
        query,
        variables: req
      },
      {
        headers
      }
    )
    // if (response.data.errors) {
    //   throw new Error(response.data.errors[0].message)
    // }
    return response?.data?.data
  } catch (error) {
    console.error(error)
    return
  }
}
